import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class SendDriveThru extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1>Send Drive Thru</h1>
				<p>Send "Thank You, Drive Thru!" e-mail to a buyer</p>
				<h4>Request</h4>
				<table>
					<tbody>
						<tr>
							<th>Method </th>
							<th>URI </th>
						</tr>
						<tr>
							<td> POST </td>
							<td> {`/orders/{order_id}/drive_thru`} </td>
						</tr>
					</tbody>
				</table>
				<h4>Parameters</h4>
				<table>
					<tbody>
						<tr>
							<th>Parameter Name </th>
							<th>Value </th>
							<th>Optional </th>
							<th>Description </th>
						</tr>
						<tr>
							<td> order_id </td>
							<td> Integer </td>
							<td> N </td>
							<td> The ID of the order to update payment status </td>
						</tr>
						<tr>
							<td> mail_me </td>
							<td> Boolean </td>
							<td> Y </td>
							<td> Indicates that whether you want to cc yourself or not </td>
						</tr>
					</tbody>
				</table>
				<h4>Request body</h4>
				<p>Do not supply a request body with this method</p>
				<h4>Response</h4>
				<p>If successful, this method returns an empty "data".</p>
				<h4>Example</h4>
				<ul>
					<li>
						POST /orders/1234/drive_thru?mail_me=true
						<ul>
							<li>Send "Thank You, Drive Thru!" e-mail for order 1234 to a buyer and yourself</li>
						</ul>
					</li>
				</ul>
			</section>
		);
	}
}